import { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom'
import UserContext from '../../Context/User/userContext.jsx'; import { Avatar, TextField, Button, FormControl, InputLabel, MenuItem, Select, Grid, Checkbox, FormControlLabel, Typography, Card, Modal, Box, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import axios from 'axios';
import Swal from 'sweetalert2';


const SignUpForm = ({ setShowSpinner }) => {

  const { user, setUser } = useContext(UserContext);
  const userObj = user && (typeof user == "string" ? JSON.parse(user) : user);
  const navigate = useNavigate()
  useEffect(() => {
    if (userObj && userObj.signedDocument !== "") {
      navigate("/home")
    } else if (userObj && userObj.signedDocument == "") {
      navigate("/authentication")
    }
  }, [user, navigate]);


  const [values, setValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    showPassword: false,
    organizationName: '',
    organizationType: '',
    region: '',
    country: '',
    city: '',
    state: '',
    receiveUpdates: false,
  });

  const [openModal, setOpenModal] = useState(false);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleCheckboxChange = (event) => {
    setValues({ ...values, receiveUpdates: event.target.checked });
    if (event.target.checked) {
      setOpenModal(true);
    } else {
      setOpenModal(false);
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const reset = () => {
    setValues({
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      showPassword: false,
      organizationName: '',
      organizationType: '',
      region: '',
      country: '',
      city: '',
      state: '',
      receiveUpdates: false,
    })
  };

  const handleSignUp = (e) => {
    setShowSpinner(true);
    // 
    const { showPassword, ...restValues } = values;
    const user = { ...restValues, approvedByAdmin: false };
    e.preventDefault()

    axios.post('https://research-mate-b35a10757d5a.herokuapp.com/api/auth/signin', user)
      .then(res => {
        localStorage.setItem('user', JSON.stringify(res.data.user))
        localStorage.setItem('token', JSON.stringify(res.data.token))
        setUser(res.data.user)
        // Reset the form after successful submission
        reset();
      })
      .catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setShowSpinner(false);
      })
  };

  return (
    <div className='form-cont'>
      <Card style={{ maxWidth: '650px', marginTop: '180px', padding: '20px', background: 'transparent' }}>
        <Avatar sx={{ m: 1, marginLeft: '50%', bgcolor: '#178383' }}>
          <LockOutlinedIcon />
        </Avatar>
        <h4 style={{ color: '#178383',fontFamily:'nunito' }}>
        Register Your Site ..!
        </h4>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              value={values.firstName}
              onChange={handleChange('firstName')}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              value={values.lastName}
              onChange={handleChange('lastName')}
              margin="normal"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              label="Email"
              value={values.email}
              onChange={handleChange('email')}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Password"
              type={values.showPassword ? 'text' : 'password'}
              value={values.password}
              onChange={handleChange('password')}
              margin="normal"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Organization Name"
              value={values.organizationName}
              onChange={handleChange('organizationName')}
              margin="normal"
              fullWidth
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Organization Type</InputLabel>
              <Select
                value={values.organizationType}
                onChange={handleChange('organizationType')}
                label="OrganizationType"

              >
                <MenuItem value="CRO/SPONSORS">CRO/SPONSORS</MenuItem>
                <MenuItem value="SMO">SMO</MenuItem>
                <MenuItem value="Sites">Sites</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Country</InputLabel>
              <Select
                value={values.country}
                onChange={handleChange('country')}
                label="Country"
              >
                <MenuItem value="USA">USA</MenuItem>
                <MenuItem value="Canada">Canada</MenuItem>
                <MenuItem value="UK">United Kingdom</MenuItem>
                <MenuItem value="Germany">Germany</MenuItem>
                <MenuItem value="France">France</MenuItem>
                <MenuItem value="Italy">Italy</MenuItem>
                <MenuItem value="Japan">Japan</MenuItem>
                <MenuItem value="China">China</MenuItem>
                <MenuItem value="India">India</MenuItem>
                <MenuItem value="Australia">Australia</MenuItem>
                <MenuItem value="Brazil">Brazil</MenuItem>
                <MenuItem value="SouthAfrica">South Africa</MenuItem>
                <MenuItem value="Russia">Russia</MenuItem>
                <MenuItem value="Mexico">Mexico</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Region</InputLabel>
              <Select
                value={values.region}
                onChange={handleChange('region')}
                label="Region"
              >
                <MenuItem value="NorthAmerica">North America</MenuItem>
                <MenuItem value="USA">USA</MenuItem>
                <MenuItem value="Canada">Canada</MenuItem>
                <MenuItem value="Mexico">Mexico</MenuItem>
                <MenuItem value="Europe">Europe</MenuItem>
                <MenuItem value="UK">United Kingdom</MenuItem>
                <MenuItem value="Germany">Germany</MenuItem>
                <MenuItem value="France">France</MenuItem>
                <MenuItem value="Italy">Italy</MenuItem>
                <MenuItem value="Russia">Russia</MenuItem>
                <MenuItem value="Asia">Asia</MenuItem>
                <MenuItem value="Japan">Japan</MenuItem>
                <MenuItem value="China">China</MenuItem>
                <MenuItem value="India">India</MenuItem>
                <MenuItem value="Oceania">Oceania</MenuItem>
                <MenuItem value="Australia">Australia</MenuItem>
                <MenuItem value="SouthAmerica">South America</MenuItem>
                <MenuItem value="Brazil">Brazil</MenuItem>
                <MenuItem value="Africa">Africa</MenuItem>
                <MenuItem value="SouthAfrica">South Africa</MenuItem>

              </Select>
            </FormControl>
          </Grid>

        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="City"
              value={values.city}
              onChange={handleChange('city')}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="State"
              value={values.state}
              onChange={handleChange('state')}
              margin="normal"
              fullWidth
            />
          </Grid>
        </Grid>
        <FormControlLabel
          control={<Checkbox checked={values.receiveUpdates} onChange={handleCheckboxChange} />}
          label="I agree to these terms and conditions"
        />
        <Button onClick={handleSignUp} style={{backgroundColor:'#178383'}} className='mt-3' variant="contained" color="primary" fullWidth >
          Sign Up
        </Button>
        <div className='text-center'>
          <Typography  variant="body2" align="center" gutterBottom>
            Already have an account? <Link to={'/'} style={{ color: '#178383', fontSize: 20, marginLeft: 10 }}><LoginRoundedIcon style={{ fontSize: 40 }} /></Link>
          </Typography>
        </div>
      </Card>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '1200px', maxHeight: '500px', bgcolor: 'background.paper', p: 4, overflow: 'auto' }}>
          <h4 style={{ color: '#169a8f' }} id="modal-title" variant="h3" >
            Instructions
          </h4>
          <Typography id="modal-description" sx={{ mt: 2 }}>
            <p>
              Research Mate is not a provider of any type of medical services, disease treatment, medical advice, or any other such services and is not responsible in any way for these services. We are only providers of a platform to facilitate medical research and help Sponsor companies, their affiliates, Investigators, research staff, and participants reach out to each other.
            </p>
            <ul>
              <li>All information provided on this website is for informational purposes only and cannot be substituted for advice given by certified healthcare professionals, medically qualified individuals, and health care institutions and any such related companies.</li>
              <li>By browsing and using our website and services, you acknowledge that you have read, understood, and agreed to terms and conditions without any restrictions or limitations.</li>
              <li>By signing this agreement, you warrant that you are a qualified research investigator and that you will not hold Research Mate, its employees, and affiliated companies responsible for any claims, damages, and misrepresentation of information on your behalf. In addition, in the event of any legal action, commenced by you or on your behalf against Research Mate, its employees, partners, affiliated individuals or companies, or by any other person, you agree to hold us harmless and indemnify us from any and all such claims and costs of litigation.</li>
              <li>By signing this agreement, you hereby swear and confirm that all information provided or communicated by you through this website is accurate and truthful, that you assume full responsibility for all the information provided by you, and that you are in compliance with any state or federal laws applicable in your area and practice.</li>
              <li>It is mutually understood and agreed by you that your information will become part of our worldwide database and it will be provided to pharmaceutical, biotech, and research-oriented companies. And that Research Mate's website will be accessible to all our partners and subscribers. Once they have access to this information, we will not be responsible for how they use this information.</li>
              <li>You hereby agree that once a contact is made between you and a sponsor company, a delegate, or a participant, you are solely responsible to that company or individual and that Research Mate will have no obligation or responsibility to that sponsor company, their delegate, or any participant.</li>
              <li>If you are a research participant, by providing your information you hereby swear and confirm that it is accurate and that your interest and participation in any study offered by any investigator registered with Research Mate is your sole decision and not in any way influenced by Research Mate. Further, you would not hold Research Mate responsible for any direct, indirect, or punitive damages or claims in any way resulting from your participation in any study and from your use of this website.</li>
              <li>Further, as a research participant, you understand that this is a free service provided to research participants or potential participants and in the event of any legal action, commenced by you or on your behalf against Research Mate, by any other person, you agree to hold us harmless and indemnify us from any and all such claims and costs of litigation.</li>
              <li>Research Mate reserves the right to update, modify, and cancel any or all parts of these terms and agreements without any notice.</li>
              <li>Your privacy is respected and your information will be kept on our secured servers. However, we cannot guarantee data security and you would not hold us responsible and liable for any direct, indirect, or punitive damages in any way for any such information leaked through circumstances outside Research Mate's control.</li>
              <li>Upon your signing and acceptance of this agreement, it is understood that this constitutes the entire agreement between you and Research Mate and neither you nor Research Mate is bound by any terms, conditions, and agreements, written or verbal, not herein contained.</li>
            </ul>

          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default SignUpForm;
